module.exports = __webpack_public_path__ + "static/img/100080.73c95b30.png";